import { render, staticRenderFns } from "./Payslip.vue?vue&type=template&id=6a0f902a"
import script from "./Payslip.vue?vue&type=script&lang=js"
export * from "./Payslip.vue?vue&type=script&lang=js"
import style0 from "./Payslip.vue?vue&type=style&index=0&id=6a0f902a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports